declare const process: { env: { NODE_ENV: string } };

export const isDev = process.env.NODE_ENV === 'development';
